// Rótulo "código - nome" usado nos cadastros orçamentários (unidade, programa e ação)
export function formatCodeName(item?: { code?: string; name?: string }): string {
    return item ? [item.code, item.name].filter(Boolean).join(' - ') : '';
}
